/** Sigma renders with WebGL: a browser without it (hardware acceleration off, strict fingerprinting shields) must not mount the graph. */
export function isWebGlAvailable(): boolean {
  try {
    const canvas = document.createElement("canvas");
    return !!(canvas.getContext("webgl") || canvas.getContext("experimental-webgl"));
  } catch {
    return false;
  }
}
